import axios from "axios";
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Css/AddQueForm.css';
import API_BASE from "../config/api";

const AddQuestionForm = ({ questionData, onSave, onCancel }) => {
  const [question, setQuestion] = useState('');
  const [answers, setAnswers] = useState(['', '', '', '']);
  const [answerImages, setAnswerImages] = useState([null, null, null, null]);
  const [correctIndex, setCorrectIndex] = useState(null);
  const [explanation, setExplanation] = useState('');
  const [mark, setMark] = useState('');
  const [difficulty, setDifficulty] = useState('');
  const [questionImage, setQuestionImage] = useState(null);
  const navigate = useNavigate();
  const [explanationImage, setExplanationImage] = useState(null);
  const [softwares, setSoftwares] = useState([]);
  const [standards, setStandards] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [topics, setTopics] = useState([]);
  const [subtopics, setSubtopics] = useState([]);

  const [selectedSoftware, setSelectedSoftware] = useState("");
  const [selectedStandard, setSelectedStandard] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("");
  const [selectedSubtopic, setSelectedSubtopic] = useState("");
  const [paperTypes, setPaperTypes] = useState([]);
  const [answerTypes, setAnswerTypes] = useState([]);
  const [papers, setPapers] = useState([]);
  const [selectedPaper, setSelectedPaper] = useState("");


  const [dropdown1, setDropdown1] = useState('');
  const [dropdown2, setDropdown2] = useState('');
  const [dropdown3, setDropdown3] = useState('');
  const handleInputChange = (field, value) => {
  };

  useEffect(() => {
    loadSoftwares();
    loadStandards();
    loadEnums();
  }, []);

  useEffect(() => {
    if (questionData) {
      setQuestion(questionData.question || '');
      const initialOptions = questionData.options?.slice(0, 4) || ['', '', '', ''];
      setAnswers(initialOptions);
      const correctIdx = initialOptions.findIndex(opt => opt === questionData.answer);
      setCorrectIndex(correctIdx !== -1 ? correctIdx : null);
      setExplanation(questionData.explanation || '');
      setQuestionImage(questionData.questionImage || null);
      setAnswerImages(questionData.answerImages || [null, null, null, null]);
    }
  }, [questionData]);

  const loadSoftwares = async () => {
    const res = await axios.get(`${API_BASE}/api/questions/softwares`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });
    setSoftwares(res.data);
  };

  const loadStandards = async () => {
    const res = await axios.get(`${API_BASE}/api/questions/standards`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });
    setStandards(res.data);
  };

  const loadEnums = async () => {
    const pt = await axios.get(`${API_BASE}/api/questions/paper-types`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });
    const at = await axios.get(`${API_BASE}/api/questions/answer-types`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });

    setPaperTypes(pt.data);
    setAnswerTypes(at.data);
  };

  const handleSoftwareChange = async (id) => {
    setSelectedSoftware(id);

    await loadPapers(id);

    setSubjects([]);
    setTopics([]);
    setSubtopics([]);
  };

  const handleStandardChange = async (id) => {
    setSelectedStandard(id);

    const filtered = softwares.filter(x => x.standardId == id);
    setSoftwares(filtered);

    await loadSubjects(id);
  };

  const loadPapers = async (softwareId) => {
    const res = await axios.get(
      `${API_BASE}/api/questions/papers/${softwareId}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      }
    );

    setPapers(res.data);
  };

  const handlePaperChange = async (paperId) => {
    setSelectedPaper(paperId);

    await loadSubjects(paperId);
  };

  const loadSubjects = async (paperId) => {
    const res = await axios.get(
      `${API_BASE}/api/questions/subjects/${paperId}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      }
    );

    setSubjects(res.data);
  };

  const handleSubjectChange = async (id) => {
    setSelectedSubject(id);

    const res = await axios.get(`${API_BASE}/api/questions/topics/${id}`
      ,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      }
    );
    setTopics(res.data);
  };

  const handleTopicChange = async (topic) => {
    setSelectedTopic(topic);

    const res = await axios.get(`${API_BASE}/api/questions/subtopics?subjectId=${selectedSubject}&topic=${topic}`
      ,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      }
    );
    setSubtopics(res.data);
  };

  const getOptionLetter = (index) => ["A", "B", "C", "D"][index];

  const handleSave = async () => {

    if (!selectedSoftware || !selectedSubject || !question || correctIndex === null) {
      alert("Please fill all required fields");
      return;
    }

    const formData = new FormData();

    formData.append("SoftwareId", selectedSoftware);
    formData.append("SubjectId", selectedSubject);
    formData.append("QuestionText", question);
    formData.append("Topic", selectedTopic);
    formData.append("SubTopic", selectedSubtopic);

    formData.append("OptionA", answers[0]);
    formData.append("OptionB", answers[1]);
    formData.append("OptionC", answers[2]);
    formData.append("OptionD", answers[3]);

    formData.append("CorrectAnswer", getOptionLetter(correctIndex));
    formData.append("Explanation", explanation);
    formData.append("DifficultyLevel", difficulty);
    formData.append("Mark", mark || 1);

    if (questionImage) formData.append("QuestionImage", questionImage);
    if (answerImages[0]) formData.append("OptionAImage", answerImages[0]);
    if (answerImages[1]) formData.append("OptionBImage", answerImages[1]);
    if (answerImages[2]) formData.append("OptionCImage", answerImages[2]);
    if (answerImages[3]) formData.append("OptionDImage", answerImages[3]);

    await axios.post(`${API_BASE}/api/questions/create-question`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
      }
    });

    navigate('/dashboard/quemanagment')
    alert("Question Saved");
  };

  const handleAnswerChange = (index, value) => {
    const updated = [...answers];
    updated[index] = value;
    setAnswers(updated);
  };
  const handleExplanationImageChange = (file) => {
    setExplanationImage(file);
  };


  const handleAnswerImageChange = (index, file) => {
    const updatedImages = [...answerImages];
    updatedImages[index] = file;
    setAnswerImages(updatedImages);
  };

  const handleQuestionImageChange = (file) => {
    setQuestionImage(file);
  };


  return (
    <div className="question-form-container">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          प्रश्न संच   &gt;&gt; <span>प्रश्न मजकूर जोडा </span>
        </h3>
        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
          <button
            className="btn primaryy"
            onClick={handleSave}
          >
            सेव्ह करा
          </button>

        </div>
      </div>
      <div className='question-form-header'>
        <h2>प्रश्न मजकूर जोडा </h2>
      </div>
      <div className="dropdown-row">
        <div className="dropdown-line">
          <select value={selectedSoftware} onChange={e => handleSoftwareChange(e.target.value)}>
            <option value="">परीक्षेचे नाव</option>
            {softwares.map(s => (
              <option key={s.id} value={s.id}>{s.softwareName}</option>
            ))}
          </select>

          <select>
            <option>परीक्षा प्रकार</option>
            {paperTypes.map(p => (
              <option key={p.id}>{p.name}</option>
            ))}
          </select>

          <select value={selectedStandard} onChange={e => handleStandardChange(e.target.value)}>
            <option>इयत्ता</option>
            {standards.map(s => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>

          <select
            value={selectedPaper}
            onChange={e => handlePaperChange(e.target.value)}
          >
            <option value="">पेपर</option>
            {papers.map(p => (
              <option key={p.id} value={p.id}>
                Paper {p.paperNumber}
              </option>
            ))}
          </select>

          <select value={selectedSubject} onChange={e => handleSubjectChange(e.target.value)}>
            <option>विषय</option>
            {subjects.map(s => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
        </div>

        <div className="dropdown-line">
          <select onChange={e => handleTopicChange(e.target.value)}>
            <option>घटक</option>
            {topics.map(t => (
              <option key={t}>{t}</option>
            ))}
          </select>

          <select onChange={e => setSelectedSubtopic(e.target.value)}>
            <option>उपघटक</option>
            {subtopics.map(t => (
              <option key={t}>{t}</option>
            ))}
          </select>

          <select>
            <option>उत्तर निवड प्रकार</option>
            {answerTypes.map(p => (
              <option key={p.id}>{p.name}</option>
            ))}
          </select>

          <select onChange={e => setDifficulty(e.target.value)}>
            <option>प्रश्न पातळी</option>
            <option>Easy</option>
            <option>Moderate</option>
            <option>Difficult</option>
          </select>
        </div>
      </div>

      <div className='question-form-header'>
        <label className="question-label">प्रश्न</label>
        <button className='para-btn' onClick={() => navigate('/dashboard/addpara')}>परिच्छेद प्रश्न</button>
      </div>
      <div className="answer-row">
        <input
          className="answer-input"
          placeholder="प्रश्न इथे टाका "
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
        />
        <label className="add-image-link">
          Add Image
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleQuestionImageChange(e.target.files[0])}
          />
        </label>
      </div>
      {questionImage && (
        <img
          src={URL.createObjectURL(questionImage)}
          alt="Question Preview"
          className="image-preview"
        />
      )}

      <div className='question-form-header'>
        <label className="question-label">गुण</label>
      </div>
      <div className="answer-row">
        <input
          type="number"
          placeholder="गुण"
          value={mark}
          onChange={(e) => setMark(e.target.value)}
          className="answer-input"
        />
      </div>

      <label className="question-label">उत्तर पर्याय लिहा </label>
      <p className="sub-label">बरोबर पर्याय चिन्हांकित करा</p>

      {answers.map((answer, index) => (
        <div key={index}>
          <label className="option-label">{`पर्याय 0${index + 1}`}</label>
          <div className="answer-block">
            <input
              type="checkbox"
              name="correctAnswer"
              checked={correctIndex === index}
              onChange={() => setCorrectIndex(index)}
              className="option-radio"
            />
            <div className="answer-row">
              <input
                type="text"
                className="answer-input"
                placeholder={`पर्याय ०${index + 1} लिहा`}
                value={answer}
                onChange={(e) => handleAnswerChange(index, e.target.value)}
              />

              <label className="add-image-link">
                Add Image
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleAnswerImageChange(index, e.target.files[0])}
                />
              </label>
            </div>

            {answerImages[index] && (
              <img
                src={URL.createObjectURL(answerImages[index])}
                alt={`Option ${index + 1}`}
                className="image-preview"
              />
            )}
          </div>
        </div>
      ))}
      <div className="explain">
        <label className="question-label">स्पष्टीकरण</label>

        <div className="explanation-wrapper">
          <textarea
            className="explanation-input"
            placeholder="इथे स्पष्टीकरण लिहा"
            value={explanation}
            onChange={(e) => setExplanation(e.target.value)}
            rows="4"
          />

          <label className="add-image-inside">
            Add Image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) =>
                handleExplanationImageChange(e.target.files[0])
              }
            />
          </label>
        </div>

        {explanationImage && (
          <img
            src={URL.createObjectURL(explanationImage)}
            alt="Explanation Preview"
            className="image-preview"
          />
        )}
      </div>


    </div>
  );
};

export default AddQuestionForm;
